import { useCallback } from 'react'

import { useIsActiveBreakPoint } from '@/hooks/useIsActiveBreakPoint'
import { useCookieBannerStatus } from '@/hooks/useCookieBannerStatus'
import { appSettings } from '@/shared/consts/appSettings'
import { sendEvent } from '@/services/mixPanelService'

export const useChatButton = () => {
  const isMobile = useIsActiveBreakPoint('small')
  const { state: bannerState, height: bannerHeight } = useCookieBannerStatus()
  const originPath = window.location.href

  const getButtonOffset = useCallback(() => {
    const buttonOffset = isMobile
      ? bannerHeight + appSettings.stepbarHeight
      : bannerHeight

    return Math.ceil(buttonOffset) || 0
  }, [bannerHeight, isMobile])

  const calculateOffset = useCallback(() => {
    const OFFSET_MAP = new Map([
      ['original', { mobile: getButtonOffset(), desktop: getButtonOffset() }],
      ['minified', { mobile: getButtonOffset(), desktop: 0 }],
      ['invisible', { mobile: appSettings.stepbarHeight, desktop: 0 }]
    ])

    const offset = isMobile
      ? OFFSET_MAP.get(bannerState || 'original')?.mobile
      : OFFSET_MAP.get(bannerState || 'original')?.desktop

    return offset
  }, [bannerState, isMobile, getButtonOffset])

  const sendEventOpenChatMixpanel = () => {
    sendEvent({
      eventName: 'OPEN_CHAT',
      data: { ORIGIN_PAGE: originPath }
    })
  }

  return { calculateOffset, sendEventOpenChatMixpanel }
}
